export default function About() {
  const stats = [
    { number: '10+', label: '년 경력' },
    { number: '500+', label: '만족 고객' },
    { number: '98%', label: '재방문율' },
    { number: '24/7', label: '운영 시간' },
  ];

  return (
    <section id="about" className="py-20 md:py-32 bg-black relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] opacity-5 pointer-events-none" style={{ background: 'radial-gradient(circle, #ec4899 0%, transparent 70%)', filter: 'blur(80px)' }}></div>

      <div className="max-w-6xl mx-auto px-6 md:px-8 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <div
            className="inline-block px-6 py-2 rounded-full mb-6 md:mb-8 border"
            style={{ borderColor: '#ec4899', boxShadow: '0 0 12px rgba(236,72,153,0.3)' }}
          >
            <span
              className="text-sm font-medium tracking-wider"
              style={{ color: '#ec4899', textShadow: '0 0 8px #ec4899' }}
            >
              ABOUT US
            </span>
          </div>

          <h2
            className="text-3xl md:text-5xl font-bold mb-6 leading-tight"
            style={{ fontFamily: "'Orbitron', sans-serif", color: '#fff', textShadow: '0 0 15px rgba(255,255,255,0.2)' }}
          >
            부산 최고의 호스트바<br />
            <span style={{ color: '#ec4899', textShadow: '0 0 15px #ec4899' }}>프리미엄 서비스</span>
          </h2>

          <p className="text-sm md:text-base text-gray-400 leading-relaxed max-w-3xl mx-auto">
            <strong>부산호스트바 추천 1위</strong>로 선정된 저희는 10년 이상의 경험과 노하우로 최상의 서비스를 제공합니다.
            <br className="hidden md:block" />
            부산 <strong>서면·해운대·광안리·연산동</strong> 4개 지점을 운영하는 부산 대표 호스트클럽으로,
            <br className="hidden md:block" />
            프리미엄 엔터테인먼트와 세련된 분위기 속에서 특별한 시간을 경험하실 수 있습니다.
          </p>
        </div>

        <div className="w-full h-px mb-12 md:mb-20" style={{ background: 'linear-gradient(90deg, transparent, #ec4899, #06b6d4, transparent)' }}></div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-4xl mx-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-5 md:p-8 rounded-2xl border border-gray-800 relative overflow-hidden"
              style={{ background: 'rgba(255,255,255,0.02)' }}
            >
              <div
                className="text-3xl md:text-5xl font-black mb-2 md:mb-3"
                style={{ fontFamily: "'Orbitron', sans-serif", color: index % 2 === 0 ? '#ec4899' : '#06b6d4', textShadow: index % 2 === 0 ? '0 0 15px #ec4899' : '0 0 15px #06b6d4' }}
              >
                {stat.number}
              </div>
              <div className="text-xs md:text-sm text-gray-400 tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
